import { AppConfig } from '@app/app.config';
import { HttpParams } from '@angular/common/http';
import { HttpService } from '@app/security/shared/http.service';
import { IMaterial } from '@app/materials/shared/material.interface';
import { Injectable } from '@angular/core';
import { Logger } from '@app/logger/logger';
import { LoginStatusModel } from '@app/security/shared/login-status-change.model';
import { LoginStatusService } from '@app/security/shared/login-status.service';
import { Material } from '@app/materials/shared/material.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const lgSfx = '\t(materials.service)';

@Injectable({ providedIn: 'root' })
export class MaterialService {
  public materials = Array<IMaterial>();

  constructor(
    private config: AppConfig,
    private http: HttpService,
    private log: Logger,
    private loginStatusService: LoginStatusService
  ) {
    this.loginStatusService.loginStatus.subscribe((ls) => {
      this.onLoginStatusChange(ls);
    });
  }

  public getMaterials(plantIds: Array<string>): Observable<Array<IMaterial>> {
    this.log.log(`Loading material from the server ${lgSfx}`);
    let params = new HttpParams();
    params = params.set('plantIds', plantIds.join(','));

    const API_ENDPOINT = '/api/Products';
    const endpoint = this.config.getServerUri() + API_ENDPOINT + '?' + params.toString();

    return this.http.getAny(endpoint).pipe(
      map((materialResp) => {
        this.materials = materialResp.map((material) => {
          return new Material(
            material.Id,
            material.Description,
            material.Number,
            material.ProductTypeId
          );
        });
        return this.materials;
      })
    );
  }

  private onLoginStatusChange(loginStatus: LoginStatusModel): void {
    if (loginStatus.loggedIn === false) {
      this.cleanCache();
    }
  }

  private cleanCache(): void {
    this.materials = Array<IMaterial>();
  }
}
